export default __webpack_public_path__ + "static/media/speakers.e5911f32.svg";